import { captureException } from "@sentry/react";
import { AxiosInstance, AxiosResponse } from "axios";
import { Dispatch } from "redux";
import { showNotification } from "../store/notification/actions";
import { IShowNotification } from "../store/notification/models";
import toError from "../../common/helpers/toError";

export const post = (path: string, data: any, callback?: (data: AxiosResponse) => void, callbackError?: (error: Error) => void) =>
    async (dispatch: Dispatch<IShowNotification>, _getState: any, api: AxiosInstance) => {
    try {
        const res = await api.post("/" + path, data);
        if (callback) {
            callback(res);
        }
    } catch (caught) {
        const error = toError(caught);
        if (path !== "user-analytics" && path !== "is-new-version-available") {
            dispatch(showNotification(error.toString(), "warning"));
        }
        captureException(error);
        if (callbackError) {
            callbackError(error);
        }
    }
};

export const get = <T = any>(path: string, callback?: (data: AxiosResponse<T>) => void, callbackError?: (error: Error) => void) =>
    async (dispatch: Dispatch<IShowNotification>, getState: any, api: AxiosInstance) => {
    try {
        const res = await api.get<T>("/" + path);
        if (callback) {
            callback(res);
        }
    } catch (caught) {
        const error = toError(caught);
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
        if (callbackError) {
            callbackError(error);
        }
    }
};
